
import { nextTick, reactive } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { Prop, Ref, Watch } from 'vue-property-decorator';

@Options({
  name: 'CardConfidence'
})
export default class CardConfidence extends Vue {
  @Prop({ type: String, required: true })
  readonly modelValue!: string;
}
